import { Button } from "flowbite-react";
import { ChevronLeft, ChevronRight } from "lucide-react";

type PaginationProps = {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  /** Prefix of the test identifiers, so two paginations on one page stay distinct. */
  testId?: string
};

export const Pagination = ({
  currentPage, totalPages, onPageChange, testId = "pagination",
}: PaginationProps) => {
  if (totalPages <= 1) {
    return null;
  }

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="flex items-center justify-center gap-4 py-4" data-testid={testId}>
      <Button
        color="light"
        size="sm"
        onClick={handlePrevious}
        disabled={currentPage === 1}
        data-testid={`${testId}-previous`}
      >
        <ChevronLeft size={16} className="mr-1" />
        Précédent
      </Button>

      <span className="text-sm text-gray-700 dark:text-gray-300" data-testid={`${testId}-info`}>
        Page
        {" "}
        {currentPage}
        {" "}
        sur
        {" "}
        {totalPages}
      </span>

      <Button
        color="light"
        size="sm"
        onClick={handleNext}
        disabled={currentPage === totalPages}
        data-testid={`${testId}-next`}
      >
        Suivant
        <ChevronRight size={16} className="ml-1" />
      </Button>
    </div>
  );
};
